import {CreateProps} from "react-admin";
import {CustomCreate} from "../../components/CustomCreate";
import {DocumentForm} from "./DocumentForm";

export const DocumentCreate = (props: CreateProps) => {
  return props && (
    <CustomCreate {...props}>
        <DocumentForm/>
    </CustomCreate>
  )
};

